export const selectUsers = state => state.users.userData; 
export const selectUsersStatus = state => state.users.status;

export const selectCreateUserStatus = (state) => state.users?.createStatus || "idle";
export const selectUserError = (state) => state.users?.error || null;

export const selectUpdatePasswordStatus = (state) => state.users?.updatePasswordStatus || "idle";
export const selectUpdatePasswordError = (state) => state.users?.error || null;

export const selectUpdateWorkStatusStatus = (state) => state.users?.updateWorkStatusStatus || "idle";